import { useEffect } from 'react'
import { playAnalysisReadyCue } from '../utils/sound'

interface UseResultReadySoundOptions {
  scanId: string | null
  /** True when a freshly completed result is on screen. */
  ready: boolean
  enabled: boolean
}

/** Plays the "Your analysis is ready" cue once per scan per session. */
export function useResultReadySound({ scanId, ready, enabled }: UseResultReadySoundOptions) {
  useEffect(() => {
    if (!scanId || !ready || !enabled) return
    const key = `td_ready_sound_played_${scanId}`
    try {
      if (window.sessionStorage.getItem(key) === 'true') return
      window.sessionStorage.setItem(key, 'true')
    } catch {
      /* storage unavailable — still play once for this render */
    }
    const timer = window.setTimeout(() => {
      void playAnalysisReadyCue()
    }, 350)
    return () => window.clearTimeout(timer)
  }, [scanId, ready, enabled])
}
